import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { withRouter } from "react-router";

function MainLayout({ children, location }) {
  const pathname = location.pathname.toLowerCase();
  const [active, setActive] = useState("");
  useEffect(() => {
    if (pathname === "/") setActive("home");
    else if (pathname.startsWith("/demo")) setActive("demo");
    else if (pathname === "/subscribe") setActive("subscribe");
    else if (pathname === "/learn") setActive("learn");
    else setActive("");
  }, [pathname]);
  const getClass = name => (name === active ? "menuItem active" : "menuItem");

  console.log(pathname);
  return (
    <ScrollToTop pathname={window.location.href}>
      <div>
        <div className="header">
          <div className="logo">
            <img src="/metaVOTE.png" alt="MetaVOTE" />
          </div>
          <div className="content">
            <div className="menu content">
              <div className={getClass("home")}>
                <Link to="/">Home</Link>
              </div>
              <div className={getClass("demo")}>
                <Link to="/demo/bidenvp">Biden VP</Link>
              </div>

              <div className={getClass("subscribe")}>
                <Link to="/Subscribe">Subscribe</Link>
              </div>

              <div className={getClass("learn")}>
                <Link to="/Learn">Learn More</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="content">{children}</div>
      </div>
    </ScrollToTop>
  );
}

export default withRouter(MainLayout);
